const collapsibleRegionPresenter = require('./collapsibleRegionPresenter');
const partyPresenter = require('./orderInformationPresenter/partyPresenter');
const negotiateShow = require('./orderInformationPresenter/negotiateShow');
const { setViewData, queryParser } = require('gui');
const { getTranslationDictionary } = require('core');

module.exports = function orderInformationPresenter(resultDto) {
    const c = {};
    const view = require('./orderInformationPresenter.tpl.html');
    const translationDictionary = getTranslationDictionary();
    const orderInformationString = translationDictionary.orderInformation;
    const consignorString = translationDictionary.consignor;
    const consigneeString = translationDictionary.consignee;
    const deliveryPartyString = translationDictionary.deliveryParty;

    const informationRegionPresenter = collapsibleRegionPresenter(orderInformationString);
    const consignorPresenter = partyPresenter(consignorString, resultDto.consignor);
    const consigneePresenter = partyPresenter(consigneeString, resultDto.consignee);
    const deliveryPartyPresenter = partyPresenter(deliveryPartyString, resultDto.deliveryParty);
    const transporterCode = queryParser.get('id') || 'tim';

    c.activate = function (region) {
        informationRegionPresenter.activate(region);
        const contentRegion = informationRegionPresenter.contentRegion();
        contentRegion.classList.add('orderInformationPresenter-collapsibleRegion');
        view.activate(contentRegion);
        setViewData(view, resultDto);
        consignorPresenter.activate(view.consignorRegion);
        consigneePresenter.activate(view.consigneeRegion);
        deliveryPartyPresenter.activate(view.deliveryPartyRegion);

        negotiateShow(resultDto.freeText, view.freeTextRegion, 'inherit');
        negotiateExtraReferences();
        negotiateShow(resultDto.arrivalAtdText, view.arrivalAtdRegion, 'block');
        negotiateShow(resultDto.arrivalAtaText, view.arrivalAtaRegion, 'block');
        negotiateHaugland();
    };

    c.deactivate = function () {
        deliveryPartyPresenter.deactivate();
        consigneePresenter.deactivate();
        consignorPresenter.deactivate();
        view.deactivate();
        informationRegionPresenter.deactivate();
    };

    function negotiateExtraReferences() {
        view.awbElement.href = 'http://connect.track-trace.com/for/timpex/aircargo/' + resultDto.awbReference;
        view.billOfLadingElement.href = 'http://connect.track-trace.com/for/timpex/billoflading/' + resultDto.billOfLadingReference;
        view.containerNumberElement.href = 'http://connect.track-trace.com/for/timpex/container/' + resultDto.containerNumberReference;

        negotiateShow(resultDto.awbReference, view.awbWrapperElement);
        negotiateShow(resultDto.hwbReference, view.hwbWrapperElement);
        negotiateShow(resultDto.billOfLadingReference, view.billOfLadingWrapperElement);
        negotiateShow(resultDto.containerNumberReference, view.containerNumberWrapperElement);
    }

    function negotiateHaugland() {
        if (transporterCode !== 'haugland')
            return;
        view.orderInformationPresenterPallets.style.display = 'none';
        view.orderInformationPresenterLoadingMetres.style.display = 'none';
        view.orderInformationPresenterGoodsType.style.display = 'none';
        view.orderInformationPresenterCustomersReference.style.display = 'none';

        view.orderInformationPresenterPackagesText.innerHTML = 'Kolli';
    }
    return c;
};
